<div #keypadDisplay class="tw-flex tw-w-full tw-h-full tw-justify-end tw-rounded-md tw-border tw-border-solid tw-border-gray-400 tw-truncate">
    <span [class]="inputClass" class="tw-pr-2 tw-my-auto">{{value}}</span>
</div>